import { createContext } from 'react';

// Current auth state (authenticated / username / is_admin), provided by AuthGate
// in App.js and consumed by route components (nav links, admin gating).
export const AuthContext = createContext({ authenticated: false });
